export default __webpack_public_path__ + "static/12-b5be8cd8faadac44e78deb59880aaef3.png";